import { render, staticRenderFns } from "./plantillaLight.vue?vue&type=template&id=f2cf801a&scoped=true"
import script from "./plantillaLight.vue?vue&type=script&lang=js"
export * from "./plantillaLight.vue?vue&type=script&lang=js"
import style0 from "./plantillaLight.vue?vue&type=style&index=0&id=f2cf801a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cf801a",
  null
  
)

export default component.exports